"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMarker = void 0;
var MARKER_TEST_PATTERN = /{\d{1,}}/;

var isMarker = function isMarker(item) {
  return MARKER_TEST_PATTERN.test(item);
};

exports.isMarker = isMarker;